const styles = (theme) => ({
  card: {
    marginBottom: 16,
    overflow: "inherit",
    backgroundColor: theme.ModalBGColor,
    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "4px",
  },
  title: {
    color: theme.ModalHeaderTextColor,
    fontSize: 10,
  },
  subheader: {
    color: theme.ToggleIconColor,
    fontSize: theme.textFontSize,
  },
  closeIcon: {
    color: theme.iconColor,
  },
  headerRoot: {
    padding: 12,
    borderBottom: `1px solid ${theme.dividerColor}`,
  },
  editIcon: {
    marginTop: 0,
  },
  proContentContainer: {
    padding: 8,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  cardTitleContainer:{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "start",
    color: theme.palette.primary.main,
    marginRight: 16,
  },
  cardTitlePickupNumber: {
    fontSize: theme.headerTextFontSize16,
    fontWeight: 500,
  },
  cardTitleProDetails:{
    display: "flex",
    flexDirection: "column",
    fontSize: theme.textFontSize,
  },
  cardTitleProDetailsIndex:{
    fontSize: theme.dispatchCardTextFontSize,
    fontWeight: 500,
    color: theme.iconColor
  },
  expandedCardView: {
    display: "flex",
    justifyContent: "flex-end",
    height: 26,
    margin: "0 -8 -8 -8",
  },
  pendingStatusBG: {
    backgroundColor: theme.stopsStatusBGColor,
    opacity: 0.9,
    color: theme.iconColor,
  },
  errorStatusBG: {
    backgroundColor: theme.errorBGColor,
    opacity: 0.9,
    color: theme.errorTextColor,
  },
  successStatusBG: {
    backgroundColor: theme.stopsStatusSuccessBGColor,
    opacity: 0.9,
    color: theme.successTextColor,
  },
  shipperName: {
    color: theme.iconColor,
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "19px",
  },
  shipperAddress: {
    color: theme.iconColor,
    fontSize: theme.textFontSize,
    fontWeight: 400,
    lineHeight: "16px",
    marginBottom: "10px",
  },
  delStatus: {
    fontSize: theme.dispatchCardTextFontSize,
    lineHeight: 2.5,
    marginRight: 8,
    textTransform: "uppercase",
    fontWeight: 600,
  },
  actionButton: {
    width: "49%",
  },
  submitButton: {
    width: "49%",
    "&$disabledButton": {
      backgroundColor: theme.customInputBGColor,
      color: theme.TextColor,
      opacity: 0.8,
    },
  },
  disabledButton: {},
  disableIcon: {
    cursor: "not-allowed",
    opacity: 0.7,
  },
  enableIcon: {
    cursor: "pointer",
  },
  cardActionRow: {
    display: "flex",
    justifyContent: "space-between",
  },
  cardProInfo:{
    fontSize: theme.textFontSize,
    fontWeight: 400,
    color: theme.iconColor,
    marginTop: 4,
  },
  cardProInfoValue:{
    fontWeight: 600,
    marginLeft: 4,
    marginRight: 8,
  }
});

export default styles;
